import React, { Component } from 'react'
import { Form, Input, InputNumber, Popconfirm, Icon, Upload, message, Tabs, Tag, Modal } from 'antd'
import ModalDom from '../../../../components/Modal';
import DetailTitle from '../../../../components/DetailTitle/index';
import { CustomRow, CustomCol } from '../../../../components/Custom';
import { post, config, postFrom, uploadEnclosure } from '../../../../axios';
import Choose from './Choose'
import copy from 'copy-to-clipboard'
import { Img } from 'react-image'
import explainImg from '../../../../images/explain.png'

const { TextArea } = Input;
const { TabPane } = Tabs

const typeObj = {
  '租户签约参数': { modal: 'coordinateCust', list: 'coordinateCustList' },
  '商户签约参数': { modal: 'coordinateMerchant', list: 'coordinateMerchantList' },
  '合同模板参数': { modal: 'paramJson', list: 'paramList' },
}

class TemplateUpdate extends Component {
  state = {
    visible: false,
    explainVisible: false,
    modalData: {
      autoSignPosition: {}
    },
    title: '新增',
    loading: false,
  }

  componentDidMount() {
    this.props.onRef(this)
  }

  uploadEnclosure = (name, res) => { //上传附件
    let { modalData } = this.state;
    if (modalData.attachList instanceof Array) {
        modalData.attachList.push({ name, id: res.attach_id, url: res.attach_url });
    } else {
        modalData.attachList = [{ name, id: res.attach_id, url: res.attach_url }];
    }
    modalData.fileUrl = res.attach_url
    this.setState({ modalData });
  }

  handleDeleteAttach = (index) => { //删除附件
    let { modalData } = this.state;
    modalData.attachList.splice(index, 1);
    this.setState({ modalData });
  }

  handleChoose = (type) => {
    const data = this.state.modalData[typeObj[type].modal]
    if (this.chooseRef) {
      this.chooseRef.onShow(type, data).then(res => {
        this._formatChooseData(res, type)
      }).catch(() => {})
    }
  }

  handleCancel = () => { // 关闭弹窗
    this.setState({ visible: false })
  }

  handleOk = () => { // 弹窗确定
    this.props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
        const { attachList, paramList, coordinateMerchantList, coordinateCustList, id, templateJsonVo = {} } = this.state.modalData
        const { pageNum, x, y, name, templateNo, remark } = values

        if (!this._checkFormData({ attachList, paramList, coordinateMerchantList, coordinateCustList })) {
          return false
        }

        const data = {
          id,
          autoSignPosition: { pageNum, x, y },
          name,
          templateNo,
          remark,
          fileUrl: Array.isArray(attachList) ? attachList.map(item => item.url).join('|') : '', 
          templateJsonVo: {
            paramJson: paramList.join(','),
            coordinateMerchant: coordinateMerchantList.join(','),
            coordinateCust: coordinateCustList.join(',') ,
            id: templateJsonVo.id
          }
        }
        const api = id ? 'API_contracttemplate_edit' : 'API_contracttemplate_create'
        this.setState({ loading: true })
        post({
          url: config[api],
          data
        }).then(res => {
          message.success('更新成功!')
          this.setState({ loading: false, visible: false })
          this.props.onUpdate && this.props.onUpdate()
        }).catch(err => {
          message.error(err.message || '更新失败!')
          this.setState({ loading: false })
        })
      }
    })
  }

  handleCopy = (content) => { // 复制参数信息
    copy(content)
    message.success('复制成功!')
  }

  handleShowModal = () => { // 显示说明
    this.setState({ explainVisible: true })
  }

  _formatChooseData(data, type) { // 格式化选择返回的数据
    if (!data.length) return false
    let list = []
    data.forEach(item => {
      for (let i = 1; i <= item.num; i++) {
        if (i === 1) {
          list.push(item.name)
        } else {
          list.push(item.name + '_' + (i - 1))
        }
      }
    })
    const item = typeObj[type]
    this.setState({
      modalData: {...this.state.modalData, [item.modal]: data, [item.list]: list }
    })
  }

  _formatSetChooseData(data) { // 格式化设置选择的数据
    if (!data) return []
    const list = []
    const keys = []
    data.split(',').forEach(item => {
      const temp = item.split('_')
      const temp_1 = temp[1] ? parseInt(temp[1]) + 1 : 1
      if (!list.length) {
        list.push({
          name: temp[0] || 0,
          num: temp_1,
        })
        keys.push(temp[0])
      } else {
        const i = keys.indexOf(temp[0])
        if (i === -1) {
          list.push({
            name: temp[0],
            num: temp_1,
          })
          keys.push(temp[0])
        } else {
          list[i] = {
            name: temp[0],
            num: Math.max(temp_1, (list[i].num ? parseInt(list[i].num) + 1 : 1))
          }
        }
      }  
    })
    return list
  }

  _formatModalData(modalData) {
    const data = JSON.parse(JSON.stringify(modalData || '{}'))
    const { coordinateCust, coordinateMerchant, paramJson } = data.templateJsonVo
    if (data.fileUrl) {
      data.attachList = data.fileUrl.split('|').map(item => ({ url: item }))
    }
    data.coordinateCustList = coordinateCust.split(',')
    data.coordinateMerchantList = coordinateMerchant.split(',')
    data.paramList = paramJson.split(',')
    data.coordinateCust = this._formatSetChooseData(coordinateCust)
    data.coordinateMerchant = this._formatSetChooseData(coordinateMerchant)
    data.paramJson = this._formatSetChooseData(paramJson)
    return data
  }

  _checkFormData({ attachList, paramList, coordinateMerchantList, coordinateCustList }) { // 检查发送后台数据
    if (!attachList || attachList.length === 0) {
      message.warning('请上传合同模板文件!')
      return false
    }
    if (!coordinateCustList || coordinateCustList.length === 0) {
      message.warning('请选择租户签约参数!')
      return false
    }
    if (!coordinateMerchantList || coordinateMerchantList.length === 0) {
      message.warning('请选择客户签约参数!')
      return false
    }
    if (!paramList || paramList.length === 0) {
      message.warning('请选择合同模板参数!')
      return false
    }
    return true
  }

  onShow = (modalData = {}) => {
    this.setState({
      visible: true,
      modalData: JSON.stringify(modalData) === '{}' ? {} : this._formatModalData(modalData)
    })
  }

  render() {
    const {
      state: { visible, explainVisible, modalData, title, loading },
      handleOk,
      handleCancel,
      handleChoose,
      handleDeleteAttach,
      handleCopy,
      handleShowModal
    } = this
    const { coordinateCustList, coordinateMerchantList, paramList, autoSignPosition = {}  } = this.state.modalData
    const { getFieldDecorator, getFieldValue, getFieldsValue, setFieldsValue } = this.props.form


    const explainModalConfig = {
      visible: explainVisible,
      maskClosable: false,
      width: 'auto',
      footer: null,
      onCancel: () => { this.setState({ explainVisible: false }) }
    }
    return (
      <ModalDom
        width="960px"
        title={title}
        visible={visible}
        loading={loading}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="custom">
          <Form>
            <DetailTitle title="平台签署信息" boxStyel={{ marginTop: 0 }} />
            <CustomRow>
              <CustomCol label="签署页面" required>
                {getFieldDecorator('pageNum', {
                  rules: [{ required: true, message: '请输入', }],
                  initialValue: autoSignPosition.pageNum || ''
                })(
                  <Input placeholder="请输入签署页面" />
                )}
              </CustomCol>
              <CustomCol label="X坐标" required>
                {getFieldDecorator('x', {
                  rules: [{ required: true, message: '请输入', }],
                  initialValue: autoSignPosition.x || ''
                })(
                  <InputNumber max="0.999999" min="0" />
                )}
              </CustomCol>
              <CustomCol label="Y坐标" required colStyle={{ width: 100 }}>
                {getFieldDecorator('y', {
                  rules: [{ required: true, message: '请输入', }],
                  initialValue: autoSignPosition.y || ''
                })(
                  <InputNumber max="0.999999" min="0" style={{ width: 100 }} />
                )}
              </CustomCol>
              <div style={{ margin: 8, cursor: 'pointer' }} onClick={handleShowModal}>坐标计算说明</div>
            </CustomRow>
            <DetailTitle title="模板信息" boxStyel={{ marginTop: 0 }} />
            <CustomRow >
              <CustomCol label="模板名称" required>
                {getFieldDecorator('name', {
                  rules: [{ required: true, message: '请输入', }],
                  initialValue: modalData.name
                })(
                  <Input placeholder="请输入模板名称" />
                )}
              </CustomCol>
              <CustomCol label="模板编号" required>
                {getFieldDecorator('templateNo', {
                  rules: [{ required: true, message: '请输入', }],
                  initialValue: modalData.templateNo
                })(
                  <Input placeholder="请输入模板编号" />
                )}
              </CustomCol>
            </CustomRow>
            <CustomRow divider>
              <CustomCol label="合同模板文件" required colStyle={{ width: '460px' }}>
                  <span
                      style={{
                          display: 'block',
                          padding: '0 11px',
                          height: '100%',
                          color: modalData.attachList instanceof Array && modalData.attachList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                          whiteSpace: 'nowrap',
                          overflowX: 'auto',
                          overflowY: 'hidden',
                      }}
                  >
                      {
                          modalData.attachList instanceof Array && modalData.attachList.length
                          ? modalData.attachList.map((item, index) => {
                            return <span key={index}>
                                <a
                                    href={item.url}
                                    download
                                    className="showClickDetail"
                                    style={{ color: 'inherit' }}
                                    target="_blank"
                                >{item.name || index + 1}；</a>
                                <Popconfirm
                                    placement="topRight"
                                    title={'此删除操作不可恢复，确定删除吗？'}
                                    onConfirm={() => {
                                        handleDeleteAttach(index)
                                    }}
                                    okText="删除"
                                    cancelText="取消"
                                >
                                    <span style={{ cursor: 'pointer', marginRight: '10px' }} title="删除">
                                        <Icon type="close" />
                                    </span>
                                </Popconfirm>
                            </span>

                        })
                        : "未上传"
                      }
                  </span>
              </CustomCol>
              <div className="center" style={{ marginLeft: '10px' }}>
                  <Upload {...uploadEnclosure({ accept: '', tableName: 'rent_contract', success: this.uploadEnclosure })}>
                      <span className="showClickDetail">上传</span>
                  </Upload>
              </div>
            </CustomRow>
            <CustomRow divider>
              <CustomCol label="备注" required={false} labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px' }}>
                {getFieldDecorator('remark', {
                  initialValue: modalData.remark
                })(
                  <TextArea style={{ height: '100%', padding: '11px', lineHeight: '20px' }} />
                )}
              </CustomCol>
            </CustomRow>
            <Tabs defaultActiveKey="1">
              <TabPane key="1" tab="参数信息">
                <CustomRow >
                  <CustomCol label="租户签约参数" required labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px' }}>
                    <a
                        href="javascript:;"
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            padding: '11px',
                            lineHeight: '20px',
                            color: coordinateCustList && coordinateCustList instanceof Array && coordinateCustList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                            overflowY: 'auto'
                        }}
                        onClick={() => { handleChoose('租户签约参数') }}
                    >
                        {
                            coordinateCustList && coordinateCustList instanceof Array && coordinateCustList.length
                                ? coordinateCustList.map((item, index) => (item + (coordinateCustList.length - 1 === index ? '' : ',')))
                                : '请选择'
                        }
                    </a>
                  </CustomCol>
                </CustomRow>
                <CustomRow divider>
                  <CustomCol label="商户签约参数" required labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px' }}>
                    <a
                        href="javascript:;"
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            padding: '11px',
                            lineHeight: '20px',
                            color: coordinateMerchantList && coordinateMerchantList instanceof Array && coordinateMerchantList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                            overflowY: 'auto'
                        }}
                        onClick={() => { handleChoose('商户签约参数') }}
                    >
                        {
                            coordinateMerchantList && coordinateMerchantList instanceof Array && coordinateMerchantList.length
                                ? coordinateMerchantList.map((item, index) => (item + (coordinateMerchantList.length - 1 === index ? '' : ',')))
                                : '请选择'
                        }
                    </a>
                  </CustomCol>
                </CustomRow>
                <CustomRow divider>
                  <CustomCol label="合同模板参数" required labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px' }}>
                    <a
                        href="javascript:;"
                        style={{
                            display: 'block',
                            width: '100%',
                            height: '100%',
                            padding: '11px',
                            lineHeight: '20px',
                            color: paramList && paramList instanceof Array && paramList.length ? 'rgba(0, 0, 0, 0.65)' : 'rgb(192, 191, 191)',
                            overflowY: 'auto'
                        }}
                        onClick={() => { handleChoose('合同模板参数') }}
                    >
                        {
                            paramList && paramList instanceof Array && paramList.length
                                ? paramList.map((item, index) => (item + (paramList.length - 1 === index ? '' : ',')))
                                : '请选择'
                        }
                    </a>
                  </CustomCol>
                </CustomRow>
              </TabPane>
              <TabPane tab="复制参数信息" key="2">
                <CustomRow >
                  <CustomCol label="复制租户参数" required labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px', overflowY: 'auto' }}>
                    <div style={{ padding: 10 }}>
                      {
                        coordinateCustList && coordinateCustList instanceof Array && coordinateCustList.length
                            ? coordinateCustList.map((item, index) => <Tag onClick={() => handleCopy(item)} key={index} style={{ cursor: "pointer" }}>{item}</Tag>)
                            : null
                      }
                    </div>
                  </CustomCol>
                </CustomRow>
                <CustomRow >
                  <CustomCol label="复制商户参数" required labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px', overflowY: 'auto' }}>
                    <div style={{ padding: 10 }}>
                      {
                        coordinateMerchantList && coordinateMerchantList instanceof Array && coordinateMerchantList.length
                            ? coordinateMerchantList.map((item, index) => <Tag onClick={() => handleCopy(item)} key={index} style={{ cursor: "pointer" }}>{item}</Tag>)
                            : null
                      }
                    </div>
                  </CustomCol>
                </CustomRow>
                <CustomRow >
                  <CustomCol label="复制合同参数" required labelStyle={{ height: '100px' }} colStyle={{ width: '800px', height: '100px', overflowY: 'auto' }}>
                    <div style={{ padding: 10 }}>
                      {
                        paramList && paramList instanceof Array && paramList.length
                            ? paramList.map((item, index) => <Tag onClick={() => handleCopy(item)} key={index} style={{ cursor: "pointer" }}>{item}</Tag>)
                            : null
                      }
                    </div>
                  </CustomCol>
                </CustomRow>
              </TabPane>
            </Tabs>
          </Form>
        </div>

        <Choose 
          onRef={ref => this.chooseRef = ref}
        />
        <Modal {...explainModalConfig}>
          <Img src={explainImg} />
        </Modal>
      </ModalDom>
    )
  }
}

export default Form.create()(TemplateUpdate)


// WEBPACK FOOTER //
// ./src/page/RentContract/components/TemplateUpdate/index.jsx